import React from 'react';

export const RuntimeContext = React.createContext({});

export function RuntimeContextProvider({ children }) {
	const [ context, setContext ] = React.useState({});

	const addContext = React.useCallback((extra={}) => {
		let newContext = {...context, ...extra};
		setContext(newContext);
	}, [ context ]);

	const clearContext = React.useCallback(key => {
		let newContext = {...context};
		delete newContext[key];
		setContext(newContext);
	}, [ context ]);

	return (
		<RuntimeContext.Provider value={{
			context,
			addContext,
			clearContext,
			setContext
		}}>
			{ children }
		</RuntimeContext.Provider>
	);
};

export function useRuntimeContext() {
	const context = React.useContext(RuntimeContext);
	if (!context) {
		throw new Error('[useRuntimeContext] Did you call useRuntimeContext outside a RuntimeContextProvider component?');
	}
	return context;
}
